module.exports = "/static/assets/2294846969d0c338f497994872451eb7.png";